import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestRecordPaymentList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/payments`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/payments?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}

export function requestInvoiceDueKpiList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/invoice/getInvoiceKPIS`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/invoice/getInvoiceKPIS?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}
export function requestRecievedSecurityDepositList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/payments/fetchPaymentReceivedByAccId?accountId=63cbe74f36d0565155e65d39`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/payments/fetchPaymentReceivedByAccId?accountId=${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}
export function createRecordPayment(params) {
  return fetch.post(`${BASE_URL}/api/app/payments`, params);
}

export function createStatusInvoice(params) {
  return fetch.post(`${BASE_URL}/api/app/invoice/updateInvoiceStatus`, params);
}

export function updateUTRDetails(params) {
  return fetch.post(`${BASE_URL}/api/app/invoice/updateUTRDetails`, params);
}
export function editRecordPayment(data) {
  const body = { ...data };
  return fetch.put(`${BASE_URL}/api/app/payments/${data._id}`, body);
}
